import { render, staticRenderFns } from "./FontColorButton.vue?vue&type=template&id=1111af0e"
import script from "./FontColorButton.vue?vue&type=script&lang=js"
export * from "./FontColorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports